<template>
  <div>
    <div class="form-row">
      <div class="form-group col-6">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          {{ $t('resource.format.label') }}
        </label>
        <p>{{ $t('resource.format.help') }}</p>
        <ValidatedFileFormatSelector
          :required="isRequired"
          :validation-name="`Format ${isMain ? 'resource' : 'annexe'}`"
          @select="$event => form.format = $event"
        />
        <p style="margin-top: 0.5em; font-size: 0.85em; white-space: wrap;">
          {{ $t('resource.fileUpload.formatHelp') }}
        </p>
      </div>
      <div class="col-1" />
      <div class="form-group col-5">
        <label>
          {{ $t('resource.fileUpload.file.label') }}
        </label>
        <p>{{ $t('resource.fileUpload.file.help') }}</p>
        <ImportFile
          :key="`${isMain ? 'resource' : 'annexe'}-import-file`"
          :name="isMain ? 'resource' : 'annexe'"
          :accept="form.format ?
            resourceDataFormats
              .find(el => el.codename === form.format.codename).extension
              .map(el => { return `.${el}` }).join(',') :
            ''
          "
          :disabled="!(form.format && form.format.codename)"
          :required="isRequired"
          @update="setResourceFile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ValidatedFileFormatSelector from '@/common/components/ValidatedFileFormatSelector.vue';
import ImportFile from '@/components/ImportFile.vue';

export default {
  name: 'FileUploadCreator',

  components: {
    ImportFile,
    ValidatedFileFormatSelector,
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    isMain: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      isRequired: true,
      form: {
        type: 'file-upload',
        format: null,
        file: null
      },
    };
  },

  computed: {
    ...mapState('resources', [
      'resourceDataFormats',
    ]),

    isGeospatial() {
      return this.form.format && this.form.format.type.value === 'geospatial';
    },
    isXY() {
      return this.form.format && this.form.format.type.value === 'tabular-xy';
    }
  },

  watch: {
    required(newValue) {
      this.isRequired = newValue;
    },
    form: {
      deep: true,
      handler(newValue) {
        if (newValue.format || newValue.file) {
          this.isRequired = true;
        } else {
          this.isRequired = false;
        }
        this.$emit('set', {
          required: this.isRequired,
          form: newValue
        });
      }
    },
    isGeospatial(newValue) {
      this.$emit('geo', newValue);
      this.$emit('xy', this.form.format && this.form.format.type.value === 'tabular-xy');
    },
    isXY(newValue) {
      this.$emit('xy', newValue);
    }
  },

  created() {
    this.isRequired = this.required;
    this.$emit('geo', this.isGeospatial);
    this.$emit('xy', this.isXY);
  },

  methods: {
    setResourceFile(e) {
      const formData = new FormData();
      formData.append('file', e);
      this.form.file = formData;
      this.$emit('set', {
        form: this.form,
        required: this.isRequired
      });
    }
  }
};
</script>
